import { getResizedImage } from 'shared-helpers/common';
import { hexToRgba } from 'lib/colors';

import type { CoursePicturePosition } from 'shared-types';

interface Props {
  position?: CoursePicturePosition;
  size: number;
  url: string;
}

const CoursePicture = ({ position, size, url }: Props) => {
  const color = '#999999';

  return (
    <div className="picture">
      <style jsx>{`
        .picture {
          background: ${url
            ? `url(${size ? getResizedImage({ url, size }) : url})`
            : `linear-gradient(110deg,` +
              `${hexToRgba({ hex: color, opacity: 0.2 })} 60%,` +
              `${hexToRgba({ hex: color, opacity: 0.3 })} 60%),` +
              `linear-gradient(190deg,` +
              `${hexToRgba({ hex: color, opacity: 0.4 })} 55%,` +
              `${hexToRgba({ hex: color, opacity: 0.5 })} 55%)`};
          background-size: cover;
          background-position: ${position || 'center top'};
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      `}</style>
    </div>
  );
};

export default CoursePicture;
